export const THERAPIST_PROFILES = [
  {
    id: 1,
    name: "زیگموند فروید",
    slug: "freud",
    approach: "روان‌کاوی",
    quotes: [
      "اون چیزی که امروز بهش «من» می‌گی، نتیجه‌ی هزاران لحظه‌ی خاموش توی کودکی‌ته، چیزایی که حتی یادت نمیاد اما هنوز داری باهاشون زندگی می‌کنی. فهمیدن این یعنی شروع یه گفتگوی واقعی با خودت.",
      "ممکنه بتونی توی بیداری افکار مزاحم قدیمی رو پس بزنی اما نمیتونی بیخیال تفسیر پشت خواب های تکراری معنادارت بشی!",
      "درست زمانی که فکر میکنی دارک‌ترین تجربه‌های زندگیت رو فرستادی به قبرستون خاطرات، یه «خواب دیدن» بهت یادآوری میکنه که هنوز درگیرشونی."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/freud.webp"
  },
  {
    id: 2,
    name: "کارل یونگ",
    slug: "jung",
    approach: "روان‌شناسی تحلیلی",
    quotes: [
      "تو یه عالمه «من» توی خودتی که هنوز همدیگه رو نمی‌شناسین. وقتی باهاشون دوست شدی، زندگی تازه شروع می‌شه.",
      "درون تو یه مهمونی شلوغه که هر روز مهموناش تغییر می‌کنن! خودتو زیاد جدی نگیر، بذار همه «من»‌هات بیان بیرون بازی کنن.",
      "تنهایی تو از تنها بودن نمیاد، بلکه از ناتوانی‌ت توی بیان چیزهایی میاد که واقعاً برات مهم‌اند."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/jung.webp"
  },
  {
    id: 3,
    name: "بی. اف. اسکینر",
    slug: "skinner",
    approach: "رفتاردرمانی",
    quotes: [
      "تو مثل یه رباتی که فقط دکمه‌های عادتش گیر کرده! اما خبر خوب اینه که هر وقت دلت خواست می‌تونی ریموت کنترلتو بگیری دستت و دوباره برنامه‌ریزی کنی.",
      "تو محصول تصمیماتت نیستی، تو محصول تشویق‌ها و تنبی‌هایی هستی که حتی یادت نمیاد کی شروع شدن! (ولی خبر خوب: قابل برنامه‌ریزی‌ای)",
      "جامعه از همون ابتدا بهت حمله می‌کنه، وقتی تو هنوز بی‌دفاعی."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/skinner.webp"
  },
  {
    id: 4,
    name: "مارتین سلیگمن",
    slug: "seligman",
    approach: "روان‌شناسی مثبت‌گرا",
    quotes: [
      "تو جزو بهترین افرادی هستی که می‌تونی تو ایران زندگی کنی چون نگاهت به زندگی مثبته و نیمه پر لیوان رو می‌بینی.",
      "شاد بودن قرار نیست جایزه‌ی آخر بازی باشه. شاد بودن همون چیزیه که اگه از اول تو جیبت باشه، بهتر بازی می‌کنی!",
      "همیشه بد آوردی؟ شاید... ولی شایدم فقط داری همیشه همونو تعریف می‌کنی!"
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/seligman.webp"
  },
  {
    id: 5,
    name: "آبراهام مزلو",
    slug: "maslow",
    approach: "روان‌شناسی انسان‌گرا",
    quotes: [
      "خودشکوفایی وقتی شروع می‌شه که دیگه سعی نکنی شبیه کسی باشی، بلکه شروع کنی به زندگی کردن مثل خودت.",
      "خودِ واقعی‌ت یه طبقه بالاتره، ولی اگه از ترس، پشت درِ نیازهای اولیه موندی، نه خودتو می‌بینی، نه آسمون آبی رو!",
      "تو فکر می‌کنی دنبال موفقیتی، ولی شاید فقط امنیت نداشتی و اسمشو گذاشتی جاه‌طلبی. (یه نگاهی بنداز ببین واقعاً کجای هرمی؟)"
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/maslow.webp"
  },
  {
    id: 6,
    name: "نوآم چامسکی",
    slug: "chomsky",
    approach: "روان‌شناسی شناختی",
    quotes: [
      "تو قبل از اینکه حتی بدونی چی می‌خوای بگی، یه ساختار زبانی تو ذهنت داری. اگه بفهمی چطوری با کلماتت فکر می‌کنی، خودت رو هم بهتر می‌فهمی.",
      "مشکل ما این نیست که نمی‌دونیم چی داره می‌گذره… مشکل اینه که نمی‌دونیم که نمی‌دونیم! یعنی نه فقط گم شدیم، بلکه حتی نمی‌دونیم نقشه‌ای هم وجود داره. ولی نگران نباش، تو از اونایی هستی که GPS روشن کردن، این خودش خیلیه!",
      "مغز تو کیسه‌ای از ترفندها نیست که همه‌چیز رو از تجربه‌هات یاد بگیره."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/chomsky.webp"
  },
  {
    id: 7,
    name: "دونالد وینیکات",
    slug: "winnicott",
    approach: "روان‌درمانی روابط شیء",
    quotes: [
      "همیشه از والدینت انتظار داشتی که برات بهترین باشن، اما باید بپذیری که اونا هم اولین بارشونه دارن زندگی می‌کنن و همه چیز رو بلد نبودن.",
      "رشد روانی اونجاست که بتونی در حضور یک نفر، بی‌نیاز از تأیید یا نجات، فقط خودت باشی و احساس امنیت کنی.",
      "وقتی یاد می‌گیری برای پذیرفته شدن باید نقش بازی کنی، کم‌کم فاصله می‌گیری از چیزی که واقعاً هستی!"
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/winnicott.webp"
  },
  {
    id: 8,
    name: "لئون فستینگر",
    slug: "festinger",
    approach: "روان‌شناسی شناختی",
    quotes: [
      "تضادها و ناهمخوانی‌های ذهنی برات خیلی آزاردهنده‌ هستند؟ تو تنها نیستی. کلی آدم توی مکتب فستینگر کنارتن.",
      "به نظرت مردم منطقی نیستند بلکه محاط به احساسات‌شونن؟ جای تو توی کلاس فستینگره.",
      "ذهنت نمی‌تونه راحت زندگی کنه وقتی که حرف‌هات، باورت، و رفتارت با هم جور درنمیاد. پس یا واقعیتو عوض می‌کنی… یا خودتو گول می‌زنی."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/festinger.webp"
  },
  {
    id: 9,
    name: "آلن دوباتن",
    slug: "debotton",
    approach: "درمان فلسفی",
    quotes: [
      "ظاهرا تو هم می‌دونی که چقدر نمی‌دونی... پس جات توی مدرسه زندگی ما خالیه.",
      "پس تو هم به خاطر نقص‌های پارتنرت عاشقش شدی نه کمالش... می‌دونستم جات پیش ماست.",
      "ما از یک اپیدمی جمعی ناخوشی روانی رنج می‌بریم که پشتش این فکره که زندگی باید فوق‌العاده باشه."
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/debotton.webp"
  },
  {
    id: 10,
    name: "ویکتور فرانکل",
    slug: "frankl",
    approach: "معنا درمانی",
    quotes: [
      "رنج به تنهایی مخربه مگه اینکه پشتش معنایی باشه. اگر با این جمله موافقی به گروه فرانکلی‌ها تعلق داری.",
      "همیشه میشه توی زندگی معنایی ساخت. این رو یک روانشناس انگیزشی بهت نمی‌گه ها، کسی که تو اردوگاه کار اجباری بوده داره می‌گه.",
      "همه چیز رو می‌شه از آدم‌ها گرفت جز یه چیز: انتخاب نگرش در هر شرایطی!"
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/frankl.webp"
  },
  {
    id: 11,
    name: "همون دکتری که معرف حضورتون هستن!",
    slug: "shayegan",
    approach: "فضاوت",
    quotes: [
      "فرزند چندم خانواده هستی جانم؟"
    ],
    imageUrl: "https://simiaroom.com/marketingCampaign/shayegan.webp"
  }
];
